import React, { useContext } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { observer } from 'mobx-react-lite';
import Modal from './modal';
import ButtonsContainer from 'shared/lib/components/controls/buttons/buttonsContainer';
import IconInfo from 'shared/icons/iconInfo';
import { UiContext } from 'shared/lib/contexts/uiContext';
import PrimaryButton from 'shared/lib/components/controls/buttons/primaryButton';

export default observer(function ErrorModal({
  isOpen,
  mainText,
  onClose,
  buttonText = 'Понятно',
  children,
}: {
  isOpen: boolean;
  mainText: string;
  onClose: () => void;
  buttonText?: string;
  children?: React.ReactNode;
}): JSX.Element {
  const {
    spacings: { sp },
  } = useContext(UiContext);
  const theme = useTheme();

  return (
    <Modal
      sx={{ '& .MuiDialog-paper': { gap: sp.s80 } }}
      isOpen={isOpen}
      handleClose={onClose}
    >
      <Box sx={{ display: 'flex', gap: 2.5, alignItems: 'center' }}>
        <IconInfo
          extColor={theme.palette.error.main}
          sizeKey="20x20"
        ></IconInfo>
        <Typography color="error" variant="f24">
          {mainText}
        </Typography>
      </Box>

      {children}

      <ButtonsContainer>
        <PrimaryButton onClick={onClose}>{buttonText}</PrimaryButton>
      </ButtonsContainer>
    </Modal>
  );
});
